var colors = ['#5793f3', '#52d134', '#675bba'];

export default {
  color: ['#8ADBE6', '#8AADE6', '#5793f3', '#d19a23','#d14a61','#52d134',],

  tooltip: {
    trigger: 'axis',
  },
  legend: {
    data: [],
    type: 'plain',
    right: 80,
    top: 20,
    textStyle: {
      color: '#E2E2E2'
    }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: {
    name: '日',
    type: 'category',
    data: [],
    axisTick: {
      alignWithLabel: true
    },
    axisLine: {
      lineStyle: {
        color: '#E2E2E2'
      }
    },
    axisLabel: {
      color: '#e1e1e1'
    }
  },
  yAxis: [
    {
      name: '杯',
      type: 'value',
      axisLine: {
        lineStyle: {
          color: '#BAC3CE'
        }
      },
      axisLabel: {
        color: '#e1e1e1'
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#6c6c6c',
          type: 'dashed'
        }
      }
    },
    {
      name: '元',
      type: 'value',
      axisLine: {
        lineStyle: {
          color: '#BAC3CE'
        }
      },
      axisLabel: {
        color: '#e1e1e1'
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#6c6c6c',
          type: 'dashed'
        }
      }
    }
  ],
  series: [

  ]
};
